import { Directive, ElementRef, HostListener, Input, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[NumericInput]',
})
// tslint:disable-next-line: directive-class-suffix
export class NumericInput {
  @Input() maxDigits: number;

  constructor(
    private el: ElementRef<HTMLInputElement>,
    @Optional() @Self() private ngControl: NgControl,
  ) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const e = event;
    const input = this.el.nativeElement;
    // tslint:disable-next-line: deprecation
    const allowedKeys = [46, 8, 9, 27, 13, 110, 190];
    if (
      allowedKeys.indexOf(e.keyCode) !== -1 || 
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      if (this.maxDigits != null && (e.keyCode === 110 || e.keyCode === 190)) {
        e.preventDefault();
      }
      return;
    }

    // tslint:disable-next-line: deprecation
    const isDigit =
      (!e.shiftKey && e.keyCode >= 48 && e.keyCode <= 57) ||
      (e.keyCode >= 96 && e.keyCode <= 105);

    if (!isDigit) {
      e.preventDefault();
      return;
    }

    if (this.maxDigits != null) {
      const selectionLength = (input.selectionEnd ?? 0) - (input.selectionStart ?? 0);
      const currentDigits = this.toDigits(input.value);
      if (selectionLength === 0 && currentDigits.length >= this.maxDigits) {
        e.preventDefault();
      }
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (this.maxDigits == null) {
      return;
    }
    event.preventDefault();
    const input = this.el.nativeElement;
    const pasted = (event.clipboardData?.getData('text') || '').replace(/\D/g, '');
    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;
    const current = this.toDigits(input.value);
    const merged = (current.slice(0, start) + pasted + current.slice(end)).slice(
      0,
      this.maxDigits,
    );
    this.applyDigits(merged);
  }

  @HostListener('input')
  onInput() {
    if (this.maxDigits == null) {
      return;
    }
    const input = this.el.nativeElement;
    const digits = this.toDigits(input.value).slice(0, this.maxDigits);
    if (this.toDigits(input.value) !== digits) {
      this.applyDigits(digits);
    }
  }

  private toDigits(value: string | number | null | undefined): string {
    return String(value ?? '').replace(/\D/g, '');
  }

  private applyDigits(digits: string) {
    const input = this.el.nativeElement;
    input.value = digits;
    const controlValue = digits === '' ? null : Number(digits);
    if (this.ngControl?.control) {
      this.ngControl.control.setValue(controlValue);
    }
  }
}
